export default __webpack_public_path__ + "app/images/theme-images/light/submit-btn-disabled/icon-20-send@2x.webp";